import { distinctUntilChanged, map, OperatorFunction, withLatestFrom } from "rxjs";
import { ApiStateStoreState, ApiSubstate } from "../api-state-store.service";
import { User } from "../resources/user/user";
import { Role } from "../role";
import { organizationId } from "./organization-id";

/**
 * Used to get an user id that belongs to the current organization. Used for DID requesting and assigning
 */
export function currentOrgUserId(): OperatorFunction<ApiStateStoreState, string | undefined> {
  return storeState =>
    storeState.pipe(
      withLatestFrom(storeState.pipe(organizationId())),
      map(([store, orgId]) => {
        const usersList = Object.values((store.User as ApiSubstate<User>)?.state);
        const orgUsers = usersList.filter(user => user.organizationId === orgId);
        let newUser = orgUsers.find(({ roles }) => roles.some(role => role === Role.AccountAdmin));

        if (!newUser) {
          newUser = orgUsers.find(({ roles }) =>
            roles.some(role => role === Role.OrganizationAdmin)
          );
        }

        if (!newUser) newUser = orgUsers[0];

        if (newUser) {
          return newUser.userId;
        } else {
          return undefined;
        }
      }),
      distinctUntilChanged()
    );
}
